import Service from "../service";
import AuthService from "../AuthService";

const Auth = {
  login(data) {
    return Service.post("/login", data);
  },
  register(data) {
    return Service.post('/register', data);
  },
  getUser() {
    return AuthService.get("/details");
  },
  editUser(data) {
    return AuthService.post('/editUser', data)
  },
  changePassword(data) {
    return AuthService.post('/changePassword', data)
  }
};

export default Auth;
